export const types = {
    VEHICLE_PLACEMENT_REPORT:"VEHICLE_PLACEMENT_REPORT",
    VEHICLE_PLACEMENT_REPORT_SUCCESS:"VEHICLE_PLACEMENT_REPORT_SUCCESS",
    VEHICLE_PLACEMENT_REPORT_EXPORT_SUCCESS:"VEHICLE_PLACEMENT_REPORT_EXPORT_SUCCESS",
    VEHICLE_PLACEMENT_REPORT_EXPORT:"VEHICLE_PLACEMENT_REPORT_EXPORT"
}